import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

$(document).ready(() => {

  const $body = $('body');

  const handleValidateFieldAction = (event) => {
    event.preventDefault();

    const $target = $(event.currentTarget);

    if (event.currentTarget.checkValidity() && validate_field($target)) {
      $target.removeClass( "is-invalid" ).addClass( "is-valid" );
    }
    else {
      $target.removeClass( "is-valid" ).addClass( "is-invalid" );
    }
  };
  $body.on('focusout', '#main-tso-form input.form-control, #main-tso-form textarea.form-control, .js-tso-cart input.form-control', handleValidateFieldAction);

});

const validate_isCustomerName = (s) => {
  var reg = /^[^0-9!<>,;?=+()@#"°{}_$%:]+$/;
  return reg.test(s) || s == '';
};

const validate_isName = (s) => {
  var reg = /^[^0-9!<>,;?=+()@#"°{}_$%:]+$/;
  return reg.test(s) || s == '';
};

const validate_isGenericName = (s) => {
  var reg = /^[^<>={}]+$/;
  return reg.test(s) || s == '';
};

const validate_isAddress = (s) => {
  var reg = /^[^!<>?=+@{}_$%]+$/;
  return reg.test(s) || s == '';
};

const validate_isPostCode = (s, pattern, iso_code) => {
  if (typeof iso_code === 'undefined' || iso_code == '') {
    iso_code = '[A-Z]{2}';
  }
  // if google api validation is enabled, we skip the pattern validation
  // because google api will validate the postcode and sometimes pattern not matches
  // e.g. for SI (Slovenia) pattern is 'SI-####' but valid postcodes are 1000, 1234, 2000...
  if (typeof(pattern) == 'undefined' || pattern.length == 0 || typeof useGoogleApiValidation !== 'undefined' && useGoogleApiValidation) {
    pattern = '[a-zA-Z 0-9-]+';
  }
  else {
    var replacements = {
      ' ': '( )',
      '-': '(?:-|)',
      'N': '[0-9]',
      'L': '[a-zA-Z]',
      'C': iso_code
    };
    for (var new_value in replacements)
      pattern = pattern.split(new_value).join(replacements[new_value]);
  }
  var reg = new RegExp('^' + pattern + '$');
  return reg.test(s) || s == '';
};

const validate_isCityName = (s) => {
  var reg = /^[^!<>;?=+@#"°{}_$%]+$/;
  return reg.test(s) || s == '';
};

const validate_isMessage = (s) => {
  var reg = /^[^<>{}]+$/;
  return reg.test(s) || s == '';
};

const validate_isPhoneNumber = (s) => {
  var reg = /^[+0-9. ()-]+$/;
  return reg.test(s) || s == '';
};

const validate_isDniLite = (s) => {
  var reg = /^[0-9a-z-.]{1,16}$/i;
  return reg.test(s) || s == '';
};

const validate_isEmail = (s) => {
  var reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  return reg.test(s) || s == '';
};

const validate_isDomain = (s) => {
  var reg = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;
  return reg.test(s) || s == '';
};

const validate_isPasswd = (s) => (s.length >= 8 && s.length < 72);

const validate_isHashedPassword = (s) => (s.length >= 8 && s.length < 72);

const validate_field = (element) => {
  let result;
  if (element.attr('data-validate') == 'isPostCode') {
    var selector = '#id_country';
    if (element.attr('name') == 'postcode_invoice')
      selector += '_invoice';
    var id_country = $(selector + ' option:selected').val();
    if (countries[id_country].zip_code_format == '') {
      result = true;
    }
    else if (typeof(countriesNeedZipCode[id_country]) !== 'undefined' && typeof(countries[id_country]) !== 'undefined') {
      var function_name = 'validate_' + element.attr('data-validate');
      var value = element.val();
      var needZip = countriesNeedZipCode[id_country];
      var isoCode = countries[id_country]['iso_code'];
      result = eval(function_name+"('" + value + "','" + needZip + "','" + isoCode + "')");
    }
  }
  else if (element.attr('data-validate') == 'isPhoneNumber') {
    var selector = '#code_' + element.attr('name');
    if (element.attr('name').indexOf("invoice") != -1) {
      selector += '_invoice';
    }
    var min_length = $(selector).find(':selected').attr('data-min-length');
    var max_length = $(selector).find(':selected').attr('data-max-length');
    if (min_length > 0 && max_length > 0) {
      var val = element.val().replace(/\s+/g, '');
      if (typeof eval('validate_' + element.attr('data-validate')) === "function") {
        var format_result = window['validate_' + element.attr('data-validate')](val);
      }
      if (format_result && val.length >= min_length && val.length <= max_length) {
        result = true;
      }
    }
    else {
      if (typeof eval('validate_' + element.attr('data-validate')) === "function") {
        var function_name = 'validate_' + element.attr('data-validate');
        var value = element.val();
        result = eval(function_name+"('" + value + "')");
      }
    }
  }
  else if(element.attr('data-validate')) {
    if (typeof eval('validate_' + element.attr('data-validate')) === "function") {
      var function_name = 'validate_' + element.attr('data-validate');
      var value = element.val();
      result = eval(function_name+"('" + value + "')");
    }
  }
  return result;
};